// Impact levels as they are stored on systems and in impact assessments (lowest first).
// Shown as their level number, coloured, with the translated name as title (US 9370).
export const IMPACT_LEVELS = ['Very low', 'Low', 'High', 'Very high'];

// 1–4 for a stored level, 0 when it isn't set
export function impactLevel(value) {
  return IMPACT_LEVELS.indexOf(value) + 1;
}

export function impactClass(value) {
  let level = impactLevel(value);
  if (!level) {
    return 'is-none';
  }
  return level === 4 ? 'is-high' : (level === 3 ? 'is-medium' : 'is-low');
}

// Translation key under "impact."
export function impactKey(value) {
  return value ? value.toLowerCase().replace(' ', '_') : '';
}
